var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import ParagraphsWithIcon from '@declaration/components/ParagraphsWithIcon.vue';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@declaration/layout';
import TitleImageDescriptionLayout from '@declaration/components/TitleImageDescriptionLayout.vue';
const settings = namespace('settings');
let CompensationNotCoveredGuarantee = class CompensationNotCoveredGuarantee extends Vue {
    constructor() {
        super(...arguments);
        this.illustration = require('@declaration/assets/images/documents/checklist.svg');
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    get showButton() {
        var _a, _b, _c, _d, _e;
        return ((_e = (_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.compensationNotCoveredGuarantee) === null || _d === void 0 ? void 0 : _d.displayButton) !== null && _e !== void 0 ? _e : true);
    }
    get contents() {
        return [
            {
                html: this.$tc('compensation.not_covered.guarantee.description'),
            },
            {
                icon: 'mail',
                html: this.$tc('compensation.confirmation.description.mail'),
            },
            {
                html: this.$tc('compensation.not_covered.close'),
            },
        ];
    }
};
__decorate([
    settings.Getter('setting')
], CompensationNotCoveredGuarantee.prototype, "setting", void 0);
CompensationNotCoveredGuarantee = __decorate([
    Component({
        components: {
            ParagraphsWithIcon,
            TitleImageDescriptionLayout,
        },
        meta: {
            title: 'page.title.compensation',
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            goBack: null,
        },
    })
], CompensationNotCoveredGuarantee);
export default CompensationNotCoveredGuarantee;
